// extracted by mini-css-extract-plugin
export default {"image":"styles-module__image___-7UQd"};